import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorTypeDistributionChart from "./DonorTypeDistributionChart";

// Static data for donor type distribution
const STATIC_DONOR_TYPE_DATA = {
  family: 850,
  replacement: 1200,
  voluntary: 2680,
};

const DonorTypeDistributionWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donor Type Distribution")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorTypeDistributionChart data={STATIC_DONOR_TYPE_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorTypeDistributionWrapper;
